import SectionDestacados from './SectionDestacados'

export default SectionDestacados
